/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
import GLOBAL from "../../../../setup/constants/global";
import { useDispatch } from "react-redux";
/* Import configuration ends */

/* Import redux slices component starts */
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../setup/store/slices/globalAlertSlice";
import { updateTenantAutomaticPaymentStatus } from "../../../../setup/store/slices/tenantSlice";
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import SliderButton from "../../../ui/button/SliderButton/SliderButton";
/* Import local pages and component ends */

/* Component starts */
const AutoPaymentSettings = (props) => {
  /* Props destructuring starts */
  const { automaticPaymentOn, setAutomaticPaymentOn } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  const dispatch = useDispatch();
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  const handleAutoPayment = async (isActive) => {
    // Creating or collecting payload data to be sent
    const payload = {
      status: isActive,
    };

    // Backend response. Try, Catch
    try {
      const result = await dispatch(
        updateTenantAutomaticPaymentStatus(payload)
      );

      // Handling success response
      switch (result.meta.requestStatus) {
        case GLOBAL.REJECTED:
          dispatch(
            showErrorAlert({
              title: "Error!",
              description: result.payload,
            })
          );
          break;

        case GLOBAL.FULFILLED:
          dispatch(
            showSuccessAlert({
              title: "Success!",
              description: result.payload.message,
            })
          );
          break;
      }
    } catch (error) {
      // Handling error response
      console.error(error.message);
    }
  };
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="">
      <h3 className="font_xxl">
        Auto Payment is {automaticPaymentOn ? "On" : "Off"}
      </h3>
      <SliderButton
        active={automaticPaymentOn}
        setValue={setAutomaticPaymentOn}
        onChange={handleAutoPayment}
      />
    </div>
  );
};
/* Component ends */

export default AutoPaymentSettings;
